<template>
  <div class='footer'>
      
      <el-divider></el-divider>
      <span>备案号:蜀ICP备19030100号-2</span>
      <el-divider direction="vertical"></el-divider>
      <span>友情链接</span>
      <el-divider direction="vertical"></el-divider>
      <span @click="drawer = true">联系我</span>
      <br/>
      <br/>
      
      <el-drawer
        title="联系我"
        :visible.sync="drawer"
        :direction="direction"
        :before-close="handleClose">
        <p class='info'>
          <i class="el-icon-phone"></i>QQ：188781475<br/>
          <i class="el-icon-message"></i>邮箱：eyiadmin@163.com<br/>
          <i class="el-icon-message"></i>博客：http://blog.52fx.biz/<br/>
          <i class="el-icon-message"></i>github：https://github.com/eyiadmin/<br/>
        </p>
      </el-drawer>
  </div>
</template>
<style>
  .el-divider{
    background-color: rgb(84, 92, 100);
  }
</style>
<style scoped>
    .footer{
        
        text-align: center;
        font-size: 16px;
       
    }
    .footer{
      cursor: pointer;
    }
    .copyright{
      font-size: 12px;
    }
    .info{
      font-size: 14px;
      color: #72767b;
      line-height: 25px;
    }
    
</style>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      drawer: false,
      direction: 'btt'
    }
  },
  methods: {
    handleClose (done) {
      done()
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/footer/Footer.vue